<template>
  <picture v-lazy-load  v-if="usePicture && !fallbackToOrigin">
    <source :data-srcset="tinySrc" type="image/webp" />
    <img v-lazy-load  v-bind="$attrs" :data-src="finalSrc" @error="onImgError" />
  </picture>
  <img v-lazy-load  v-else v-bind="$attrs" :data-src="finalSrc" @error="onImgError" />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  useOriginUrl: {
    type: Boolean,
    default: false,
  },
})

const CDN_DOMAIN = '' // 云端时统一改这里
const fallbackToOrigin = ref(false)

/** 拼接CDN */
const resolveSrc = (path: string) => {
  if (!path) return ''
  return path.startsWith('http') ? path : `${CDN_DOMAIN}${path}`
}

/** 原始图 */
const finalSrc = computed(() => {
  // 如果已经 fallback，就强制用原图路径
  if (fallbackToOrigin.value) {
    return resolveSrc(props.src)
  }
  return resolveSrc(props.src)
})

/** 推导 tiny webp 路径 */
const tinySrc = computed(() => {
  if (!props.src || !props.src.startsWith('/images')) return ''
  const baseName = props.src
    .replace(/^\/images/, '/images-webp')
    .replace(/\.\w+$/, '.webp')
  return resolveSrc(encodeURI(baseName))
})

/** 判断是否使用 <picture v-lazy-load > */
const usePicture = computed(() => 
  props.src &&
  !props.useOriginUrl &&
  props.src.startsWith('/images') &&
  props.src.endsWith('png')
)

/** 图片加载错误处理 */
const onImgError = (e: Event) => {
  const img = e.target as HTMLImageElement
  if (!fallbackToOrigin.value && usePicture.value) {
    // Fallback 到原图路径
    fallbackToOrigin.value = true
    img.src = resolveSrc(props.src)
  }
}
</script>
